import $ from 'jquery';
import { initForms } from './modules/forms';
import { initNavigation } from './modules/navigation';
import { initFontAwesome } from './modules/fontAwesome';
import { OffCanvas, Accordion } from 'foundation-sites';

window.jQuery = $;
window.$ = $;

(($) => {
  'use strict';

  // If Foundation modules are installed uncomment this line
  $(document).foundation();

  $(document).ready(() => {
    initForms();
    initNavigation();
    initFontAwesome();
  });

})(jQuery);
